$(document).ready(function () {
  $('#header_review .yotpo').click(function () {
    $('html, body').animate(
      {
        scrollTop: $('#yotpo_reviews').offset().top,
      },
      1000
    );
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    vertical: false,
    fade: true,
    asNavFor: '.slider-nav',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
        },
      },
    ],
  });
  $('.slider-nav').slick({
    asNavFor: '.slider-for',
    slidesToShow: 6.6,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    infinite: false,
    swipeToSlide: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: false,
    focusOnSelect: true,
  });

  if ($(window).width() < 767) {
    /*
 $('#related_products .grid--view-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    vertical:false,
    fade: false
});  */
  }
});
/*
$(window).on("load resize",function(){	
	var pheight = $('.product-single__meta').height();
	$("#product-info").css('margin-top', pheight + 130);
});
*/
$('body').on('click', '.box-header', function (e) {
  $('.box-a1').find('.level-box').stop().slideUp();
  $(this).closest('.box-a1').find('.level-box').stop().slideToggle();

  // $('.box-a1').find('.box-header').stop().removeClass('active');
  $('.box-header').not(this).removeClass('active');
  $(this).toggleClass('active');
});

$('#marquee_wrapper').insertBefore('#ProductDetails');

/**/
/*
function updateProgressBars () {
      const progressBars = document.querySelector('.hs-progress-bar')
      progressBars.style.width = progressBarWidth + '%'
    }
	jQuery('.product-swiper2').each(function(index, value){
		const swiperClasss = "swiper" + index;
		jQuery(this).addClass(swiperClasss);
      	const previousNavClasss = "swiper-button-prev" + index;
		const nextNavClasss = "swiper-button-next" + index;
		const scrollBarClasss = "swiper-scrollbar" + index;
        const scrollbars = `<div class="swiper-scrollbar ${scrollBarClasss}"></div>`;
      	jQuery(this).append(scrollbars)
		jQuery(this).parent().find(".swiper-button-prev").addClass(previousNavClasss);
		jQuery(this).parent().find(".swiper-button-next").addClass(nextNavClasss);
		jQuery(this).parent().find(".swiper-scrollbar").addClass(scrollBarClasss);
		var swiper = new Swiper(`.${swiperClasss}`, {
			slidesPerView: 1.5,
            spaceBetween: 25,
			grabCursor: true,
			navigation: {
			  nextEl: `.${nextNavClasss}`,
			  prevEl: `.${previousNavClasss}`,
			},
			scrollbar: {
			  el: `.${scrollBarClasss}`,
			  draggable: true,
			},
			breakpoints: {
			  640: {
				slidesPerView: 1.5,
            spaceBetween: 25,
			  },
			  768: {
				slidesPerView: 4,
				spaceBetween: 32,
			  },
			  1024: {
				slidesPerView: 4,
				spaceBetween: 32,
			  },
			},
		});
	})
*/

$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  var objectSelect = $('#product-info');
  if ($(window).width() < 767) {
    var objectPosition = objectSelect.offset().top - 140;
  } else {
    var objectPosition = objectSelect.offset().top;
  }
  if (scroll > objectPosition) {
    $('.productbox__sticky').addClass('active');
    $('body').addClass('productbox__sticky-active');
  } else {
    $('.productbox__sticky').removeClass('active');
    $('body').removeClass('productbox__sticky-active');
  }
});
